export default __webpack_public_path__ + "static/media/Teddybär.372d504f.png";